/**
 * Terminal escape sequences, removed.
 *
 * Terraform colourises its output and the installer drives a terminal, so about
 * a fifth of a real run's lines carry escapes — and not only the SGR colour
 * codes (`ESC[31m`) a `[0-9;]*m` pattern catches. A real apply also emits
 * `ESC[J`, `ESC[?25l`, `ESC[>4;2m`, `ESC[=1;1u` and `ESC[?2026$p`, which is why
 * this follows ECMA-48 rather than the common shortcut: a CSI is `ESC[`, any
 * parameter bytes (`0`-`?`, which includes `<=>?`), any intermediate bytes
 * (space-`/`), and one final byte (`@`-`~`). The two earlier copies of this
 * pattern — one in `failure-extract.ts`, one in the console — stopped at
 * `[0-9;?]` and so left `ESC[>4;2m` whole, in the middle of the line it was
 * supposed to clean.
 *
 * OSC (`ESC]` … BEL or `ESC\`) is covered for the window-title sequences some
 * shells emit, and the two-character escapes for the rest.
 *
 * **Only for reading.** Nothing here rewrites what is stored in the customer's
 * log group — that is their record of what ran, and the colour is part of it.
 */
/*
 * The control character is the entire point: ESC is what starts a sequence, so
 * there is no way to match one without naming it.
 */
// eslint-disable-next-line no-control-regex
const ESCAPES = /\u001b(?:\[[0-?]*[ -/]*[@-~]|\][^\u0007\u001b]*(?:\u0007|\u001b\\)|[@-Z\\-_])/g;
/**
 * The line without its escapes.
 *
 * Checks for ESC before running the pattern: four lines in five have none, and
 * on a 60,000-line log the check is most of the saving.
 */
export const stripAnsi = (line) => line.includes('\u001b') ? line.replace(ESCAPES, '') : line;
//# sourceMappingURL=ansi.js.map